<!--   
  NOTE:

  Chiedo venia per la forzatura del tipo any sugli input ma si è rivelato necessario
  in quanto, senza, provocava errori per via del fatto che i parametri indicati in seguito sono 
  talvolta presenti solo per alcuni DTO (ISimpleInput invece che ICheckboxInput per intendersi) 
-->

<ion-content [fullscreen]="true" class="page-content" color="light">
  <modal-container (onSubmit)="onSubmit()" (generateData)="generateData()" [formStatus]="formStatus"
    [breadcrumbsList]="breadcrumbsList" [showGenerateDataButton]="showGenerateDataButton">
    @if (formGroup) {
    @if (structureSaveError) {
      <p class="structure-save-error" role="alert">{{structureSaveError}}</p>
    }
    @if (structureSaving) {
      <p class="structure-save-progress" role="status">Salvataggio di unità, stanze e letti in corso…</p>
    }
    <mat-grid-list cols="8" rowHeight="36px" gutterSize="20">
      <!-- Simple form -->
      @switch(formData.formType) {
      @case('simple') {
      <ng-container [formGroup]="formGroup">
        <ng-container *ngFor="let structure of formData.structure, index as structureIndex"
          [formGroupName]="structure.id">
          <!-- Titolo della macrosezione -->
          <mat-grid-tile colspan="8" rowspan="1">
            <b>{{'FORM.LABELS.'+structure.title | translate}}</b>
          </mat-grid-tile>

          <!-- Riga vuota per dare spazio, a sx della sezione -->
          <mat-grid-tile colspan="1" [rowspan]="structure.heightInRows"></mat-grid-tile>

          <!-- Mostra la sezione con il tipo di visualizzazione indicata -->
          @for (children of structure.children; track children.id; let childrenIndex = $index) {
          @switch(children.childrenType) {
          <!-- Sezione con visualizzazione ad accordion -->
          @case('accordion') {
          <!-- Se l'accordion è aperto allora gli do altezza 4 altrimenti 1 -->
          <mat-grid-tile colspan="6" [rowspan]="children.rowSpan || 1" style="overflow: visible;">
            <mat-accordion style="height: 100%; width: 100%;">
              <mat-expansion-panel [expanded]="children.isAccordionOpen"
                (opened)="onAccordionAction(true, children, structure)"
                (closed)="onAccordionAction(false, children, structure)"
                [style.height]="children.isAccordionOpen ? '100%' : ''">
                <mat-expansion-panel-header>
                  <mat-panel-title style="font-weight: bold;">Stanza
                    {{formGroup.get(structure.id)?.value[childrenIndex][$any(children.inputs)[0].id] ||
                    ""}}</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-grid-list cols="6" rowHeight="36px" gutterSize="20">
                  <ng-container *ngIf="!children.hideSection" [formGroupName]="childrenIndex">
                    <ng-container *ngFor="let childInput of children.inputs" [ngSwitch]="childInput.type">
                      <!-- Input semplice -->
                      <mat-grid-tile [colspan]="$any(childInput).length" [rowspan]="childInput.id === 'avatar' ? 2 : 1"
                        class="inputGrid" *ngSwitchDefault>
                        <mat-form-field appearance="outline">
                          <mat-label>{{'FORM.LABELS.'+$any(childInput).label | translate}}</mat-label>
                          <input matInput sanitizeInput [inputRule]="$any(childInput).inputRule"
                            [placeholder]="$any(childInput).placeholder" [formControlName]="childInput.id">
                        </mat-form-field>
                      </mat-grid-tile>

                      <ng-container *ngSwitchCase="'inputArray'" [formGroupName]="childInput.id">
                        <!-- Input semplice -->
                        <mat-grid-tile *ngFor="let input of $any(childInput).inputs; index as inputIndex"
                          [colspan]="$any(input).length" [rowspan]="1" class="inputGrid" [formArrayName]="inputIndex">
                          <mat-form-field appearance="outline">
                            <mat-label>{{'FORM.LABELS.'+$any(input).label | translate}}</mat-label>
                            <input matInput sanitizeInput [inputRule]="$any(input).inputRule"
                              [placeholder]="$any(input).placeholder" [formControlName]="input.id">
                            <button type="button" style="background-color: transparent;" matSuffix mat-icon-button
                              aria-label="Rimuovi letto"
                              [disabled]="structureSaving || structureReloadRequired || ($any(input).entityId && !canDeleteStructureItems)"
                              (click)="removeItem('inputArray', inputIndex, structure, $any(formGroup.get(structure.id)?.get(childrenIndex+'')?.get(childInput.id)), $any(childInput), children)">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2" rowspan="1">
                          <ion-button type="button" color="primary" [disabled]="structureSaving || structureReloadRequired"
                            (click)="addItem('inputArray', structure, $any(childInput), $any(formGroup.get(structure.id)?.get(childrenIndex+'')?.get(childInput.id)), children)">
                            <ion-icon slot="start" name="add"></ion-icon>
                            {{'GENERAL.BUTTONS.ADD_BED' | translate}}
                          </ion-button>
                        </mat-grid-tile>
                      </ng-container>

                    </ng-container>
                    <!-- Pulsante rimozione stanza -->
                    <mat-grid-tile colspan="6" rowspan="1">
                      <hr style="width: 30%; border: 0; border-top: 2px solid #ccc;">
                      <ion-button color="danger" style="width: 30%;"
                        (click)="removeItem('accordion', childrenIndex, structure)"
                        [disabled]="structureSaving || structureReloadRequired || structure.children.length === 1 || (children.entityId && !canDeleteStructureItems)">
                        <!-- <ion-icon slot="start" name="remove"></ion-icon> -->
                        {{'GENERAL.BUTTONS.REMOVE_ROOM' | translate}}
                      </ion-button>
                      <hr style="width: 30%;  border: 0; border-top: 2px solid #ccc;">
                    </mat-grid-tile>

                  </ng-container>
                </mat-grid-list>
              </mat-expansion-panel>
            </mat-accordion>
          </mat-grid-tile>
          }
          @default {
          @if (!children.hideSection) {
          <ng-container [formGroupName]="children.id">
            <!-- titolo della sezione -->
            <mat-grid-tile colspan="6" rowspan="1">
              <!-- Titolo della sezione di Inputs -->
              <b>{{'FORM.LABELS.'+children.title | translate}}</b>
              <!-- Se abilitato flag di visibilità score sezione allora mostro lo score -->
              <span style="margin-left: auto; font-weight: bold;" *ngIf="children.score"
                [class]="children.score.grade || ''">{{children.score.current+'/'+children.score.max}}</span>
            </mat-grid-tile>
            <!-- inputs -->
            @for (input of children.inputs; track input.id; let inputIndex = $index) {
            <mat-grid-tile [colspan]="$any(input).length"
              [rowspan]="$any(input).rowSpan || 1" class="inputGrid" [ngSwitch]="input.type">
              @switch (input.type) {
              <!-- Input semplice -->
              @default {
              <mat-form-field appearance="outline">
                <mat-label>{{'FORM.LABELS.'+$any(input).label | translate}}</mat-label>
                <input matInput sanitizeInput [inputRule]="$any(input).inputRule"
                  [placeholder]="$any(input).placeholder" [formControlName]="input.id">
              </mat-form-field>
              }
              <!-- Input data -->
              @case ('date') {
              <mat-form-field appearance="outline">
                <mat-label>{{'FORM.LABELS.'+$any(input).label | translate}}</mat-label>
                <input matInput [matDatepicker]="picker" [placeholder]="$any(input).placeholder"
                  [formControlName]="input.id">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              }
              <!-- Testo -->
              @case ('simpleText') {
              <mat-label>
                {{'FORM.LABELS.'+$any(input).label | translate}}
                <mat-icon *ngIf="$any(input).infoText" [matTooltip]="'FORM.LABELS.'+$any(input).infoText | translate"
                  style="color: #24a0edb8;">info</mat-icon>
              </mat-label>
              }
              <!-- Toggle -->
              @case ('toggle') {
              <div class="toggle-field">
                <div class="toggle-field__copy">
                  <strong>{{'FORM.LABELS.'+$any(input).label | translate}}</strong>
                  @if ($any(input).description) {
                  <span>{{'FORM.LABELS.'+$any(input).description | translate}}</span>
                  }
                </div>
                <ion-toggle mode="ios" [formControlName]="input.id"
                  [attr.aria-label]="'FORM.LABELS.'+$any(input).label | translate"></ion-toggle>
              </div>
              }
              <!-- Checkbox -->
              @case ('checkbox') {
              @if (!$any(input).adjustSectionVisibility) {
              <ion-checkbox labelPlacement="end" mode="md" [formControlName]="input.id"
                (ionChange)="$any(input).completeSection ? autoCompleteSection(structure.id, children.id, $event.detail.checked) : ''">{{'FORM.LABELS.'+$any(input).label
                | translate}}</ion-checkbox>
              } @else {
              <ion-checkbox labelPlacement="end" mode="md" [checked]="isDynamicSectionsExisting"
                (ionChange)="changeDynamicSectionsVisibility($event.detail.checked)">{{'FORM.LABELS.'+$any(input).label
                | translate}}</ion-checkbox>
              }
              }
              <!-- Select -->
              @case ('select') {
              <mat-form-field appearance="outline">
                <mat-label style="display: flex;">
                  {{'FORM.LABELS.'+$any(input).label | translate}}
                  <mat-spinner class="spinner" diameter="20" *ngIf="$any(input).isLoading"></mat-spinner>
                </mat-label>
                <mat-select [formControlName]="input.id"
                  (selectionChange)="checkLoader($any(children.inputs), $event.value, inputIndex)">
                  @for (item of $any(input).values; track item) {
                  <mat-option [value]="item.id" [disabled]="item.disabled">{{$any(input).disableTranslation ?
                    item.label : ('FORM.LABELS.'+item.label | translate)}}</mat-option>
                  }
                </mat-select>
                <button mat-button matSuffix
                  *ngIf="$any(input).allowClear && formGroup.controls[structure.id].get(children.id)?.get(input.id)?.value"
                  mat-icon-button aria-label="Clear" style="padding: 10px; background-color: transparent;"
                  (click)="$event.stopPropagation(); formGroup.controls[structure.id].get(children.id)?.get(input.id)?.reset()">
                  <mat-icon style="color: rgba(0, 0, 0, 0.54);">close</mat-icon>
                </button>
              </mat-form-field>
              }
              <!-- Autocomplete -->
              @case ('autocomplete') {
              <mat-form-field appearance="outline">
                <mat-label>{{'FORM.LABELS.'+$any(input).label | translate}}</mat-label>
                <input matInput type="text" sanitizeInput [inputRule]="$any(input).inputRule"
                  [placeholder]="$any(input).placeholder" [formControlName]="input.id" [matAutocomplete]="auto"
                  [disabled]="!$any(input).suggestedItems?.length">
                <mat-icon matSuffix>search</mat-icon>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this, input.id)">
                  @for (option of ($any(input).suggestedItems.length ? $any(input).suggestedItems : []); track option)
                  {
                  <mat-option [value]="option.id">{{option.label}}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              }
              <!-- Avatar -->
              @case ('avatar') {
              <avatar [formControlName]="input.id" style="margin: auto;"></avatar>
              }
              }
            </mat-grid-tile>
            }
            <!-- TextLines - Se presenti righe di testo allora le mostro nel formato specificato dall'oggetto -->
            @if (children.textLines) {
            <ng-container *ngFor="let item of children.textLines">
              <ng-container *ngIf="item.type === 'textValue'">
                <mat-grid-tile colspan="5" rowspan="1">{{'FORM.TEXT_LINES.'+item.text | translate}}</mat-grid-tile>
                <mat-grid-tile colspan="1" rowspan="1"><span
                    style="margin-left: auto;">{{item.value}}</span></mat-grid-tile>
              </ng-container>
            </ng-container>
            }
          </ng-container>
          }
          }
          }
          }
          <!-- PULSANTI AGGIUNTA E RIMOZIONE EDIFICIO -->
          @if (structure.canAddAndRemove) {
          <!-- Pulsante rimozione risorsa -->
          @if (structure.children[0].childrenType !== 'accordion') {
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%; border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <ion-button color="danger" (click)="removeItem('section', structure.id)">
              <ion-icon slot="start" name="remove"></ion-icon>
              {{'GENERAL.BUTTONS.REMOVE_'+structure.categoryLabel | translate}}
            </ion-button>
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%;  border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          }
          <!-- Pulsante aggiunta risorsa, lo mostro solo per l'ultima sezione della lista -->
          @if (formData.structure.length === (structureIndex+1)) {
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%; border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <ion-button (click)="addItem('section')">
              <ion-icon slot="start" name="add"></ion-icon>
              {{'GENERAL.BUTTONS.ADD_'+structure.categoryLabel | translate}}
            </ion-button>
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%;  border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          }
          }
          <!-- PULSANTE AGGIUNTA STANZA -->
          @if (structure.dynamicChildren) {
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%; border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <!-- DISABILITO IL PULSANTE SE NON É STATO ASSEGNATO UN NUMERO ALL'ULTIMA STANZA IN ELENCO -->
            <ion-button (click)="addItem('accordion', structure)"
              [disabled]="structureSaving || structureReloadRequired || (structure.children.length > 0 && !formGroup.get(structure.id)?.get((structure.children.length - 1)+'')?.get('name')?.value)">
              <!-- <ion-icon slot="start" name="add"></ion-icon> -->
              {{'GENERAL.BUTTONS.ADD_'+structure.categoryLabel | translate}}
            </ion-button>
          </mat-grid-tile>
          <mat-grid-tile colspan="2" rowspan="1">
            <hr style="width: 100%;  border: 0; border-top: 2px solid #ccc;">
          </mat-grid-tile>
          }
        </ng-container>
      </ng-container>
      }
      }
    </mat-grid-list>
    @if (spatialScope; as scope) {
      <app-spatial-editor [scope]="scope" [unitName]="spatialUnitName"></app-spatial-editor>
    }
    }
  </modal-container>
</ion-content>
